@if (loading) {
  <div class="text-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

@if (logs.length === 0 && !loading) {
  <div class="text-center">
    No Logs were found.
  </div>
}

@if (logs.length > 0 && !loading) {
  <div class="card">
    <div class="card-body">
      <div class="acitivity-timeline py-3">
        @for (log of logs; track log) {
          <div class="acitivity-item py-3 d-flex">
            <div class="flex-shrink-0 avatar-xs acitivity-avatar">
              <div class="avatar-title rounded-circle shadow" [ngClass]="log.action_type === 'CREATE' ? 'bg-success-subtle text-success' : log.action_type === 'UPDATE' ? 'bg-warning-subtle text-warning' : 'bg-danger-subtle text-danger'">
                {{ log.user.person.first_name.charAt(0).toUpperCase() }}{{ log.user.person.last_name.charAt(0).toUpperCase() }}
              </div>
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="mb-1">{{ log.user.person.first_name | titlecase }} {{ log.user.person.last_name | titlecase }}
                <span class="badge align-middle" [ngClass]="log.action_type === 'CREATE' ? 'bg-success-subtle text-success' : log.action_type === 'UPDATE' ? 'bg-warning-subtle text-warning' : 'bg-danger-subtle text-danger'">
                  {{ log.action_type | titlecase }}
                </span>
              </h6>
              <p class="text-muted mb-2">
                {{ log.description.message }}
              </p>
              <small class="mb-0 text-muted">{{ log.createdAt | dateFormatter  }}</small>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}